import script from "./StepButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StepButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__